// Longer than the three parallel 4-minute provider deadlines plus reference
// preparation. A claim past this deadline is abandoned, not live work.
export const AD_IDENTITY_PACK_STALE_MS = 15 * 60 * 1000;